// ./router.js
import React from "react";
import "./assets/style/style.scss";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/width.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./components/Layouts/Layout";
import HttpClient from "./Services/HttpClient";
import Login from "./screen/Login/Login";
import ForgetPass from "./screen/ForgetPass/ForgetPass";
import ReserPass from "./screen/ReserPass/ReserPass";
import HomeScreen from "./screen/HomeScreen/HomeScreen";
import Admin from "./screen/Admin/Admin";
import AddAdmin from "./screen/Admin/AddAdmin";
import Help from "./screen/Help/Help";
import { HelpEdit } from "./screen/Help/HelpEdit";
import About from "./screen/About/About";
import AboutEdit from "./screen/About/AboutEdit";
import FAQ from "./screen/FAQ/FAQ";
import FAQEdit from "./screen/FAQ/FAQEdit";
import Notification from "./screen/Notification/Notification";
import DeliveryNotification from "./screen/Notification/DeliveryNotification";
import NotificationAdd from "./screen/Notification/NotificationAdd";
import DeliveryNotificationAdd from "./screen/Notification/DeliveryNotificationAdd";
import Roles from "./screen/Roles/Roles";
import AddRole from "./screen/Roles/AddRole";
import Users from "./screen/Users/Users";
import UserDetails from "./screen/Users/UserDetails";
import UserVerification from "./screen/Users/UserVerification";
import FoodsManagement from "./screen/Foods/FoodsManagement";
import OrdersManagement from "./screen/Orders/OrdersManagement";
import Transactions from "./screen/Transactions/Transactions";
import BlockedSeller from "./screen/BlockedSeller/BlockedSeller";
import FoodsManagementView from "./screen/Foods/FoodsManagementView";
import OrdersManagementView from "./screen/Orders/OrdersManagementView";
import BlockedSellerView from "./screen/BlockedSeller/BlockedSellerView";
import InappUpdate from "./screen/InappUpdate/InappUpdate";
import Subscription from "./screen/Subscription/Subscription";
import SubscriptionView from "./screen/Subscription/SubscriptionView";
import Master from "./screen/Master/Master";
import Video from "./screen/Videos/Video";
import AddVideo from "./screen/Videos/AddVideo";
import PromotionBanner from "./screen/PromotionBanner/PromotionBanner";
import PromotionBannerAdd from "./screen/PromotionBanner/PromotionBannerAdd";
import AvailabilityDuration from "./screen/Master/AvailabilityDuration";
import PinCode from "./screen/PinCode/PinCode";
import PinCodeView from "./screen/PinCode/PinCodeView";
import PinCodeUser from "./screen/PinCode/PinCodeUser";
import Config from "./screen/Master/Config";
import DeliveryPricing from "./screen/Master/DeliveryPricing";
import DeliveryPartner from "./screen/DeliveryPartner/DeliveryPartner";
import DeliveryPartnerView from "./screen/DeliveryPartner/DeliveryPartnerView";
import DeliveryPartnerOrderView from "./screen/DeliveryPartner/DeliveryPartnerOrderView";
import DriverDocument from "./screen/DeliveryPartner/DriverDocument";
import WalletTransaction from "./screen/WalletTransaction/WalletTransaction";
import WithdrawRequest from "./screen/WithdrawRequest/WithdrawRequest";
import AdminCommission from "./screen/AdminCommission/AdminCommission";
import DriverVerification from "./screen/DeliveryPartner/DriverVerification";
import DeliveryHelp from "./screen/DeliveryPartnerHelp/Help";
import { HelpEdit as DeliveryHelpEdit } from "./screen/DeliveryPartnerHelp/HelpEdit";
import ClosedRequset from "./screen/ClosedRequset/ClosedRequset";
import { ClosedRequsetEdit } from "./screen/ClosedRequset/ClosedRequsetEdit";

const AppRoutes = () => {
  const token = localStorage.getItem("token");

  return (
    <Routes>
      <Route
        path="/"
        element={token ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route path="/forgot-password" element={<ForgetPass />} />
      <Route path="/reset-password" element={<ReserPass />} />
      {/* 
      <Route path="/refer-page" element={<ReferPage />} /> */}

      <Route element={<Layout />}>
        <Route path="/dashboard" element={<HomeScreen />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/add-admin" element={<AddAdmin />} />
        <Route path="/help" element={<Help />} />
        <Route path="/help-edit" element={<HelpEdit />} />

        <Route path="/delivery-help" element={<DeliveryHelp />} />
        <Route path="/delivery-help-edit" element={<DeliveryHelpEdit />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-edit" element={<AboutEdit />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/faq-edit" element={<FAQEdit />} />
        <Route path="/faq-edit" element={<FAQEdit />} />
        <Route path="/notifications" element={<Notification />} />
        <Route
          path="/delivery-notifications"
          element={<DeliveryNotification />}
        />
        <Route path="/notification-add" element={<NotificationAdd />} />
        <Route
          path="/delivery-notification-add"
          element={<DeliveryNotificationAdd />}
        />
        <Route path="/roles" element={<Roles />} />
        <Route path="/add-roles" element={<AddRole />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users-view" element={<UserDetails />} />
        <Route path="/user-verification" element={<UserVerification />} />
        <Route path="/foods" element={<FoodsManagement />} />
        <Route path="/foods-view" element={<FoodsManagementView />} />
        <Route path="/orders" element={<OrdersManagement />} />
        <Route path="/orders-view" element={<OrdersManagementView />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/master/kilometer-radius" element={<Master />} />
        <Route
          path="/master/food-availability-duration"
          element={<AvailabilityDuration />}
        />
        <Route path="/video" element={<Video />} />
        <Route path="/add-video" element={<AddVideo />} />
        <Route path="/promotion-banner" element={<PromotionBanner />} />
        <Route path="/promotion-banner-add" element={<PromotionBannerAdd />} />
        <Route path="/blocked" element={<BlockedSeller />} />
        <Route path="/blocked-view" element={<BlockedSellerView />} />
        <Route path="/inappUpdate" element={<InappUpdate />} />
        <Route path="/subscription-view" element={<SubscriptionView />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/pincode" element={<PinCode />} />
        <Route path="/pincode-view" element={<PinCodeView />} />
        <Route path="/pincode-user" element={<PinCodeUser />} />
        <Route path="/master/config" element={<Config />} />
        <Route path="/master/delivery-pricing" element={<DeliveryPricing />} />
        <Route path="/delivery-partner" element={<DeliveryPartner />} />
        <Route
          path="/delivery-partner-view"
          element={<DeliveryPartnerView />}
        />
        <Route
          path="/delivery-partner-order-view"
          element={<DeliveryPartnerOrderView />}
        />
        <Route path="/driver-document" element={<DriverDocument />} />
        <Route path="/driver-verification" element={<DriverVerification />} />
        <Route path="/wallet-transaction" element={<WalletTransaction />} />
        <Route path="/withdraw-request" element={<WithdrawRequest />} />
        <Route path="/admin-commission" element={<AdminCommission />} />
        <Route path="/closed-requset" element={<ClosedRequset />} />
        <Route path="/closed-requset-view" element={<ClosedRequsetEdit />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
